module.exports = __webpack_public_path__ + "media/bootstrap-icons/diagram-3-fill-8e4b218f.svg";